export default __webpack_public_path__ + "static/media/Addidas.9ce9f042.webp";